import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  Navbar as BNavbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { withUser } from '../auth/withUser';
import { isDataManager } from '../../role/roleUtils';
import { logout, redirectLogin } from '../../sessionMonster';
import { store } from '../../store';

const toggleLoginOrLogout = (e, doLogout) => {
  e.preventDefault();
  if (doLogout) {
    logout(store);
  } else {
    redirectLogin();
  }
};

class NavbarUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this);
    this.navigatePath = this.navigatePath.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  navigate(e) {
    e.preventDefault();
    this.navigatePath(e.target.attributes.href.value);
  }

  navigatePath(path) {
    const { history } = this.props;
    history.push(path);
  }

  toggle() {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }));
  }

  render() {
    const { isOpen } = this.state;
    const {
      user, authorities,
    } = this.props;

    const displayName = user.get('displayName');
    const showLogout = Boolean(user.get('userName'));
    const dataManager = isDataManager(authorities);

    return (
      <div className="haz-navbar-wrapper">

        <BNavbar color="dark" dark expand="lg">

          <NavbarToggler aria-label="Navigation Toggle" onClick={this.toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
              <NavItem>
                <NavLink tag={Link} to="/view/about" title="About NCEI Hazards" aria-label="About">About</NavLink>
              </NavItem>

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret title="Earthquake Dropdown Menu" aria-label="Earthquake Dropdown Menu">Earthquakes</DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/earthquake/search')} title="Event Search" aria-label="Event Search">
                    Events
                  </DropdownItem>
                  {dataManager && (<DropdownItem divider />)}
                  {dataManager && (
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/earthquake/update')} title="Add Earthquake Event" aria-label="Add Earthquake Event">
                    Add Event
                  </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret title="Tsunami Dropdown Menu" aria-label="Tsunami Dropdown Menu">Tsunamis</DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/event-search')} title="Event Search" aria-label="Event Search">
                    Events
                  </DropdownItem>
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/runup-search')} title="Runup Search" aria-label="Runup Search">
                    Runups
                  </DropdownItem>
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/deposit-search')} title="Deposit Search" aria-label="Deposit Search">
                    Deposits
                  </DropdownItem>
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/marigram-search')} title="Marigram Search" aria-label="Marigram Search">
                    Marigrams
                  </DropdownItem>
                  {dataManager && (<DropdownItem divider />)}
                  {dataManager && (
                    <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/update-tsunami')} title="Add Event" aria-label="Add Event">
                      Add Event
                    </DropdownItem>
                  )}
                  {dataManager && (
                    <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/update-runup')} title="Add Runup" aria-label="Add Runup">
                      Add Runup
                    </DropdownItem>
                  )}
                  {dataManager && (
                    <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/update-deposit')} title="Add Deposit" aria-label="Add Deposit">
                      Add Deposit
                    </DropdownItem>
                  )}
                  {/* {dataManager && ( */}
                  {/*  <DropdownItem onClick={() => this.navigatePath('/view/hazards/tsunami/update-marigram')} title="Add Marigram" aria-label="Add Marigram"> */}
                  {/*    Add Marigram */}
                  {/*  </DropdownItem> */}
                  {/* )} */}
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret title="Volcano Dropdown Menu" aria-label="Volcano Dropdown Menu">Volcanoes</DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/volcano/event-search')} title="Event Search" aria-label="Event Search">
                    Events
                  </DropdownItem>
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/volcano/loc-search')} title="Location Search" aria-label="Location Search">
                    Locations
                  </DropdownItem>
                  {dataManager && (<DropdownItem divider />)}
                  {dataManager && (
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/volcano/event-update')} title="Add Volcano Event" aria-label="Add Volcano Event">
                    Add Event
                  </DropdownItem>
                  )}
                  {dataManager && (
                  <DropdownItem onClick={() => this.navigatePath('/view/hazards/volcano/loc-update')} title="Add Volcano Location" aria-label="Add Volcano Location">
                    Add Location
                  </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>

              {dataManager && (
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret title="Reference Dropdown Menu" aria-label="References Dropdown Menu">References</DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => this.navigatePath('/view/reference/search')} title="Reference Search" aria-label="Reference Search">
                    Search
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={() => this.navigatePath('/view/reference/update')} title="Add Reference" aria-label="Add Reference">
                    Add Reference
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              )}
              <NavItem>
                <NavLink tag={Link} to="/view/swagger" title="API Documentation" aria-label="API">API Help</NavLink>
              </NavItem>
            </Nav>
            <form className="form-inline my-2 my-lg-0" onSubmit={e => toggleLoginOrLogout(e, showLogout)}>
              <span className="haz-display-name">{displayName}</span>
              <Button type="submit" color="secondary" className="mr-3">{showLogout ? 'Log Out' : 'Log In'}</Button>
            </form>
          </Collapse>
        </BNavbar>
        {/* <address><a href="mailto:haz.info@noaa.gov">Contact us: haz.info@noaa.gov</a></address> */}

      </div>
    );
  }
}

NavbarUnwrapped.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  user: ImmutablePropTypes.map.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};

export const Navbar = withUser(NavbarUnwrapped);
